import { render } from "./ExpressQuestionsWithoutPrice.vue?vue&type=template&id=1f461858&scoped=true"
import script from "./ExpressQuestionsWithoutPrice.vue?vue&type=script&lang=js"
export * from "./ExpressQuestionsWithoutPrice.vue?vue&type=script&lang=js"

import "./ExpressQuestionsWithoutPrice.vue?vue&type=style&index=0&id=1f461858&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f461858"]])

export default __exports__